export default __webpack_public_path__ + "static/media/imgLetsGo.a5a17c7d.png";